(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["aly-upsell"] && !Shopify.designMode) return;
  try {
    document.addEventListener("DOMContentLoaded", function () {
  // Qty plus/minus
  document.querySelectorAll(".qty-minus").forEach(btn => {
    btn.addEventListener("click", function () {
      let input = this.nextElementSibling;
      if (parseInt(input.value) > 1) input.value = parseInt(input.value) - 1;
    });
  });
  document.querySelectorAll(".qty-plus").forEach(btn => {
    btn.addEventListener("click", function () {
      let input = this.previousElementSibling;
      input.value = parseInt(input.value) + 1;
    });
  });

  // ✅ Function to mark button as "Added"
  function markAsAdded(productId) {
    let btn = document.querySelector(`form[data-product-id="${productId}"] .add-to-cart-btn`);
    if (btn) {
      btn.classList.add("added");
      btn.innerHTML = "✔ Added";
    }
  }

  // ✅ Check cart on page load & mark products
  fetch("/cart.js")
    .then(res => res.json())
    .then(cart => {
      cart.items.forEach(item => {
        markAsAdded(item.product_id);
      });
    });

  // AJAX Add to Cart
  document.querySelectorAll(".custom-add-to-cart").forEach(form => {
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      let formData = new FormData(form);
      let btn = form.querySelector(".add-to-cart-btn");

      fetch("/cart/add.js", {
        method: "POST",
        body: formData,
        credentials: "same-origin"
      })
        .then(res => res.json())
        .then(data => {
          console.log("Product Added:", data);

          // ✅ Mark the product permanently as added
          markAsAdded(data.product_id);

          // ✅ Update cart count live
          return fetch("/cart.js");
        })
        .then(res => res.json())
        .then(cart => {
          document.querySelectorAll(".cart-count, [data-cart-count]").forEach(el => {
            el.innerText = cart.item_count;
          });

          // Trigger cart drawer if available
          if (window.Shopify && Shopify.theme && Shopify.theme.cartDrawer) {
            document.dispatchEvent(new CustomEvent("cart:refresh", { detail: cart }));
          }
        })
        .catch(err => console.error("Add to cart error:", err));
    });
  });
});
  } catch(e) { console.error(e); }
})();

})();
